export default "__VITE_ASSET__0a62a7f3__"